import { AutogenModelEdiBrltlOrderFreightGroupItem, AutogenRowEdiBrltlOrderFreightGroupItem } from "./autogen/AutogenModelEdiBrltlOrderFreightGroupItem";

export class ModelEdiBrltlOrderFreightGroupItem extends AutogenModelEdiBrltlOrderFreightGroupItem<RowEdiBrltlOrderFreightGroupItem> {
	constructor() {
		super(RowEdiBrltlOrderFreightGroupItem);
	}
}

export class RowEdiBrltlOrderFreightGroupItem extends AutogenRowEdiBrltlOrderFreightGroupItem {
}